<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">科室分类</div>
            <el-select v-model="edit_DepartmentClassId" clearable placeholder="请选择科室分类" style="width: 80%">
              <el-option
                  v-for="item in class_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
            <el-button style="float: right;" type="primary" plain icon="el-icon-plus" @click.native="addClass"></el-button>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">科室名称</div>
            <el-input v-model="edit_Name" placeholder="请输入科室名称" ></el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">排序</div>
            <el-input v-model="edit_sort" placeholder="请输入排序" ></el-input>
          </el-col>
        </el-row>

      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {DepartmentClass} from "@/common/DictType";
import {emptyUUID} from "@/common/const";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      edit_Name:'',
      edit_sort:'',
      departmentId:'',

      edit_DepartmentClassId:'',
      class_list:[],

      status_arr:[{value:1,label:'正常'},{value:2,label:'禁用'}],

    }
  },
  methods: {
    init(row){

      this.edit_Name = row.name;
      this.edit_sort = row.sort;

      this.edit_DepartmentClassId = row.departmentClassId;

      this.departmentId=row.id;

      this.getClassList();

    },

    closeSelf() {
      this.loading= false
      this.$emit("closeEdit");
    },

    getClassList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Dict/AdmList',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          dictType:DepartmentClass,
          parentDictId:emptyUUID,
        }
      }).then( (response)=> {
        //console.log(response);

        if(response.data.error == 0){
          this.class_list = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },
    addClass(){

      this.$prompt('请输入科室分类名称', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //inputErrorMessage: '邮箱格式不正确'
        beforeClose: (action, instance, done) => {// 取消回车确认事件
          if (action === 'confirm') {
            instance.$refs['confirm'].$el.onclick = function (e) {
              e = e || window.event;
              if (e.detail !== 0) {
                console.log('ok');
                done();
              }
            }();
          }
          else {
            console.log('cancel');
            done();
          }
        }
      }).then(({ value }) => {

        if(value == null){
          this.$message({type: 'warning', message: '科室分类名称不能为空'});
        }
        else{
          this.$axios({
            method: 'post',
            url: this.$shopUrl+'Dict/AdmAdd',
            data: {
              timeStr:timeStr,
              sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
              staffCode: getStaffCode(),
              name:value,
              dictType:DepartmentClass,
              parentDictId:emptyUUID,
            }
          }).then( (response)=> {
            //console.log(response);

            if(response.data.error == 0){
              this.getClassList();
            }else if(response.data.error == 1){
              this.$message(response.data.message);
            }else{
              console.log(response.data.message);
            }

          }).catch(function (error) {
            console.log(error);
          });
        }

      }).catch(() => {

      });

    },


    confirm(){

      if(this.edit_DepartmentClassId == '' || this.edit_DepartmentClassId == null){
        this.$message("选择科室分类");
        return;
      }

      if(this.edit_Name === ''){
        this.$message("输入科室名称");
        return;
      }
      if(this.add_sort === ''){
        this.$message("输入排序");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Department/AdmEdit',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name: this.edit_Name,
          sort:this.edit_sort,
          departmentId:this.departmentId,
          departmentClassId:this.edit_DepartmentClassId,
        }
      }).then( (response)=> {
        //console.log(response)
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeEdit");
          this.$emit("getList");
        }else{
          this.$message(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>

